export default "__VITE_ASSET__7b390208__"